import { Controller } from 'stimulus'

export default class extends Controller {
  onScroll() {
    let el = document.querySelector("#footer-bottom")
    let sticky = document.querySelector("#purchase-footer")

    if (el && sticky) {
      if (this.elementInViewport(el)) {
        sticky.classList.add("opacity-0")
      } else {
        sticky.classList.remove("opacity-0")
      }
    }
  }

  elementInViewport(el) {
    var top = el.offsetTop;
    var left = el.offsetLeft;
    var width = el.offsetWidth;
    var height = el.offsetHeight;

    while(el.offsetParent) {
      el = el.offsetParent;
      top += el.offsetTop;
      left += el.offsetLeft;
    }

    return (
      top < (window.pageYOffset + window.innerHeight) &&
      left < (window.pageXOffset + window.innerWidth) &&
      (top + height) > window.pageYOffset &&
      (left + width) > window.pageXOffset
    );
  }
}
